import * as React from "react"
import tw from "twin.macro"

import Content from "../components/pwcomps/content"
import BreadCrumb from "../components/breadcrumb"
import Footer from "../components/footer"
import Seo from "../components/seo"
import { StoreView } from "../components/storeLocatorComponent"
import Parrafo from "../components/pwcomps/parrafo"
import CTAButtons from "../components/pwcomps/ctaButtons"

const PageStore = props => {
  const { pageContext } = props
  const { ruta, lang, tienda, store_data, content } = pageContext
  return (
    <>
      <Seo pageContext={pageContext} />
      <div css={tw`px-5 md:px-9 overflow-x-visible`}>
        <div
          css={tw`max-w-screen-xl my-0 mx-auto px-0 font-obbody overflow-x-visible`}
        >
          <article>
            <div css={tw`relative `}>
              <BreadCrumb pageContext={pageContext} />

              <StoreView store_data={store_data} />

              <div css={tw`my-4 md:mt-12 md:mb-8`}>
                <CTAButtons tiendaId={store_data.idstore} />
              </div>
              {store_data.description && (
                <div css={tw`my-4 md:mt-12 md:mb-8`}>
                  <Parrafo
                    content={{
                      type: "parrafo",
                      data: {
                        title_tipo: "TIPO_4",
                        texto_con_formato1: store_data.description,
                      },
                    }}
                  />
                </div>
              )}
              <Content contents={content} lang={lang} pageRuta={ruta} />
              <Content contents={tienda} lang={lang} pageRuta={ruta} />
            </div>
          </article>
        </div>
      </div>
      <Footer lang={lang} langSettings={pageContext.langSettings} />
    </>
  )
}

export default PageStore
